import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M8540 16194c-501-46-752-104-1060-243-481-218-850-573-1139-1096-103-187-225-486-292-712-11-40-25-73-30-73-6 0-557 180-1226 400s-1218 399-1219 397c-4-3-244-2398-244-2428 0-14-22-17-147-23-639-29-1288-147-1883-342-201-66-634-225-647-237-2-3 238-517 533-1143l538-1137-29-21c-625-448-1118-910-1571-1475L0 7907v-392l915-585c503-322 913-589 911-595-3-5-34-73-69-150-223-486-386-1027-471-1560-33-204-80-656-69-665 4-4 546-80 1203-169 657-88 1197-165 1201-169s128-557 276-1229c147-673 271-1223 275-1223s521 225 1149 499l1142 499 93-121c377-496 812-955 1247-1317 186-154 511-400 518-392 4 4 323 446 709 982s704 977 706 979 79-32 172-77c533-258 1126-434 1777-527 277-39 625-73 625-61 0 6 52 530 115 1164 63 635 115 1159 115 1166 0 10 47 14 188 19 457 16 890 95 1310 239 218 74 376 143 617 268 271 140 295 154 295 166 0 8-372 925-825 2036l-23 57 145 92c565 357 1034 787 1350 1237 61 87 284 445 320 514 1 3-444 286-989 628-546 342-999 628-1006 635-11 10 4 47 81 201 254 508 419 994 527 1549 26 134 111 687 106 691 0 1-530 72-1176 158s-1185 159-1196 161c-21 5-22 12-28 172-26 642-126 1132-328 1608-87 205-323 643-345 638-4-1-507-198-1118-438-610-241-1119-441-1130-445-17-6-33 7-94 76-389 439-568 895-522 1329 9 86 109 557 137 648 6 20 33 21-296-9m-154-396c-54-260-46-581 19-825 103-387 355-794 707-1140l103-101 1100 433c605 238 1104 431 1109 428 16-11 164-323 213-454 90-236 164-520 202-776 39-257 46-363 46-710 0-189 2-343 4-343s526-70 1163-155c638-85 1166-155 1174-155 20 0 18-33-11-200-123-702-363-1355-709-1930l-75-125 48-30c658-410 1961-1232 1961-1237 0-26-185-285-308-433-99-118-351-369-477-474-240-200-544-411-832-576-84-48-153-92-153-97s189-473 420-1041c231-567 418-1038 415-1045s-65-42-139-77c-602-286-1231-418-1918-403-195 4-218 3-218-11 0-39-230-2304-234-2308-6-6-226 22-411 53-660 110-1290 326-1819 623-70 39-129 71-131 69-1-2-311-433-689-958-379-525-692-959-696-964-17-18-380 289-636 537-334 323-741 805-1000 1185-17 25-35 41-44 38-8-2-496-214-1083-471-588-257-1070-465-1072-463-3 2-115 508-250 1124-135 615-249 1128-254 1139-8 19-93 32-1142 174-624 84-1144 155-1157 158-28 7-28 25-1 208 94 645 295 1271 596 1858 42 81 74 149 72 151s-443 284-979 626c-536 343-978 626-982 629-8 7 124 175 271 346 127 147 456 480 616 623 262 234 534 445 817 635l147 98-68 142c-389 819-971 2055-971 2063 0 11 318 121 500 173 567 162 1129 247 1718 258 160 3 292 10 292 14 0 25 231 2313 234 2316 1 2 538-173 1192-388s1193-392 1197-392c5-1 24 63 43 143 238 1010 721 1653 1448 1924 161 60 449 127 630 145 5 1 5-14 2-31" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.828 994.003)" /><path d="M7970 15160c-484-86-776-329-895-745-49-172-59-260-56-515 1-129 3-255 4-279l2-43-84-24c-406-118-595-365-552-721 14-114 18-125 39-114 35 18 191 51 289 61 239 25 536-40 831-180 390-186 767-472 1217-924 391-392 769-842 1160-1381 188-259 186-257 192-252 7 8-74 345-132 547-131 453-282 847-481 1251-254 515-471 854-1019 1594-392 530-528 781-566 1044-28 197 29 433 151 628 22 35 40 66 40 69 0 7-29 3-140-16" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.926 994.019)" /><path d="M10200 13394c-377-157-686-287-688-289s44-94 102-204c346-656 651-1404 845-2077 177-615 299-1297 332-1864 16-277 15-276 81-75 165 501 267 1009 325 1615 26 268 26 1117 0 1405-39 427-99 841-182 1240-53 257-118 535-125 535-3 0-313-129-690-286" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.973 994.042)" /><path d="M4320 13385c0-10-38-334-85-720-47-387-85-704-85-706s161-2 357-1c469 5 764-14 1188-74 922-131 1882-431 2879-900 110-52 201-92 203-90 8 8-264 262-481 449-1131 972-2347 1627-3698 1991-259 70-278 74-278 51" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.892 994.046)" /><path d="M11866 11398c-56-1409-375-2718-970-3987-48-101-84-186-81-189 10-11 347 308 577 546 733 759 1348 1730 1777 2804 116 292 288 784 277 795-2 2-342 46-757 98s-768 97-785 100l-31 5z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.993 994.074)" /><path d="M3755 11299c-499-19-1065-76-1565-158-136-22-165-29-162-43 2-14 570-1429 575-1434 1-2 79 33 172 78 930 439 1906 770 2875 974 389 82 912 163 1260 195 126 11 156 16 149 24-8 7-271 73-479 119-900 200-1860 283-2825 245" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.86 994.078)" /><path d="M7710 10233c-453-48-903-238-1245-525-461-386-752-918-825-1508-15-126-12-430 5-566 116-882 725-1615 1578-1899 261-87 502-121 801-112 502 14 936 167 1336 468 419 315 731 787 854 1290 47 196 61 316 60 554 0 236-12 342-61 544-51 211-157 467-270 651-368 598-995 1005-1686 1095-108 14-446 19-547 8m495-778c311-53 592-200 821-429 570-570 615-1446 106-2077-444-551-1222-720-1852-404-367 184-639 495-774 884-123 354-112 742 33 1094 156 383 483 703 866 850 113 44 275 84 385 96 109 12 300 6 415-14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.914 994.094)" /><path d="M5445 10131c-1456-368-2667-994-3785-1956-153-132-421-380-428-397-3-6 1245-844 1271-853 7-3 46 53 87 122 98 166 361 561 490 738 129 176 372 479 526 655 152 174 620 643 794 794 353 309 755 609 1123 840 86 54 157 102 157 107s-1 9-2 8c-2 0-106-26-233-58" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.847 994.095)" /><path d="M13103 9108c-5-7-34-53-63-103-81-136-290-453-403-610-674-937-1496-1732-2484-2403-84-57-153-106-153-109 0-9 64 6 263 63 1489 426 2802 1155 3975 2208 97 87 120 112 110 122-15 14-1226 844-1232 844-2 0-8-6-13-12" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.98 994.111)" /><path d="M4723 8778c-813-726-1490-1628-1979-2633-189-389-327-732-475-1175-91-274-97-295-78-298 25-4 1614-160 1615-158 1 1 6 154 13 341 17 491 46 841 107 1255 144 986 451 1916 882 2668 38 67 66 122 61 122s-71-55-146-122" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.862 994.114)" /><path d="M4786 7229c-193-626-311-1227-373-1899-23-248-26-1085-5-1330 43-503 116-946 234-1423 39-159 55-207 65-202 25 9 1408 619 1412 622 3 2-14 38-38 81-91 165-343 687-424 877-432 1018-692 2041-807 3174-11 113-22 207-25 209-2 2-19-47-39-109" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.895 994.138)" /><path d="M12910 6353c-128-75-542-285-715-362-981-441-2047-717-3150-816-173-15-465-35-519-35s-14-17 152-64c1524-433 2993-498 4467-196 195 40 502 114 511 123 2 2-136 310-307 683-370 807-331 724-338 723-3 0-49-26-101-56" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.958 994.152)" /><path d="M5540 5981c0-4 27-100 59-212 441-1514 1103-2745 2005-3728 141-154 390-401 403-401 8 1 964 1248 970 1267 2 6-52 41-119 78-445 245-946 580-1337 893-709 567-1365 1263-1910 2025-61 85-71 96-71 78" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.913 994.159)" /><path d="M6990 5169c0-15 347-358 505-500 387-345 782-641 1233-923 455-284 1107-605 1657-816 332-128 910-319 923-306 3 3 47 328 98 723s95 733 98 751l5 32h-162c-685 1-1542 107-2266 281-670 161-1435 439-2022 734-38 20-69 30-69 24" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.061 0 0 -.061 7.935 994.171)" /></svg>;
export default Component;
export { Component as ReactComponent };